<template>
  <div class="chart-table">
    <div v-if="title" class="m-title">{{ title }}</div>
    <div class="board-box core" v-loading="loading">
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-inline" style="width: 260px">
          <input type="text" autocomplete="off" class="layui-input" placeholder="请输入查询条件"
            v-model="tableObj.queryObject['WORK_ORDER_NUM:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2']"/>
        </div>
        <div class="layui-inline"><label class="layui-search-label">时间:</label></div>
        <div class="layui-inline" style="width: 200px">
          <layui-daterange class="dateRange"  v-model="tableObj.queryObject.TIME_RANGE" @dateChange="handleDateChange($event)"  ref="daterange"></layui-daterange>
        </div>
        <button class="layui-btn layuiadmin-btn-list" @click="$refs.tId.search()" title="查询">查询</button>
        <button class="layui-btn fold-flag advanced" title="高级搜索" @click="advancedShow = !advancedShow" v-if="tabConfig.searchConfig && tabConfig.searchConfig.advanced.length">高级搜索</button>
        <div style="float: right;">
            <button class="layui-btn refresh" title="刷新列表" @click="$refs.tId.reset();$refs.daterange.reset();">
              <i class="layui-icon">&#xe669;</i>
              刷 新
            </button>
        </div>
      </div>
      <advanced-query ref="advancedObj" v-show="advancedShow" :tableObj="tableObj" :advanced="tabConfig.searchConfig.advanced"></advanced-query>
      <layui-table
        v-if="tabConfig.serName"
        :ref="tId"
        :table-name="tabConfig.serName"
        :defaultCondition="tabConfig.condition"
        :page-size="20"
        :page-range="6"
        :page-options="[10, 20, 50, 100]"
        :skin="'line'"
        :sort="tabConfig.sort"
        :height="height"
        :before-load="() => (loading = true)"
        :after-load="() => (loading = false)"
        @table-event-detail="detail($event.data)"
      >
        <div>
          <div align="center" field="_NUMBER" title="序号" width="60" fixed="left"></div>
          <layui-tableconfig :config="tabConfig.cols"></layui-tableconfig>
          <div align="center" fixed="right" title="操作" width="60">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="detail" >查看</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>

<script>
import comTable from './mixins/comTable'
/**
 * 表格
 */
export default {
  mixins: [comTable],
  name: 'ChartTable3',
  props: {
    height: { type: String, default: '260' }
  },
  components:{
  },
  data() {
    return {
      advancedShow:false,
      tabConfig: {
        serName: 'YW_WORK_ORDER_SERVICE_COUNT_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'service',
        condition: {
          /**
           * 现场服务单-弱电工程完工 现场服务单
           * - 项目经理
           */
        },
        cols: [
          { title: '工单状态', field: 'ORDER_STATE_DESC' , width: 130},
          {
            title: '工单类型',
            field: 'WORK_ORDER_CATEGORY_DESC',
            width: 130,
            translateDomain: 'TRNSLATE_WORK_ORDER_CATEGORY'
          },
          { title: '服务请求单编号', field: 'WORK_ORDER_NUM', width: 150 },
          { title: '品牌', field: 'BRAND_NAME', width: 300 },
          { title: '门店', field: 'STORE_NAME', width: 450 },
          { title: '项目经理', field: 'MANAGER_NAME', width: 300},
          // { title: '进场时间', field: 'SIGNIN_TIME', width: 200 },
          // { title: '完工时间', field: 'SIGNOUT_TIME' , width: 200},
          { title: '现场服务单次数', field: 'SERVICE_ORDER_COUNT', width: 150, sort: true}
        ],
        searchConfig: {
          advanced: [
            { TYPE:'input', NAME: '品牌 :', FIELD:'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '项目经理 :', FIELD:'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件'}
          ]
        },
        sort:['YW_SERVICE_ORDER_UPDATE_TIME:DESC'],
      },
      

      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
    }
  },
  mounted() {
    this.tableObj = this.$refs.tId;
  },
  methods: {
    handleDateChange(daterange){
      this.tableObj.queryObject.TIME_RANGE = daterange;
      var range = daterange.split(' - ');
      var startTime = range[0];
      var endTime = range[1];
      this.tableObj.queryObject["YW_WORK_ORDER_CREATE_TIME:5"] = startTime;
      this.tableObj.queryObject["YW_WORK_ORDER_CREATE_TIME:6"] = endTime + " 23:59:59";
    }
  }
}
</script>
<style scoped>
  .layui-inline >>> .layui-icon-date{
    top: -2px !important;
  }
  .layui-card-header.layuiadmin-card-header-auto {
    padding-top: 4px;
    padding-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartTable3.vue